<template>
    <!-- 销售记录 -->
    <div class='sale-record'>
        <p class="required">保留会员最近一年的消费记录详情</p>
        <el-table v-loading="isLoading"
            ref="elTable"
            style="width: 100%"
            :height="'100%'"
            :data="saleRecord"
            :empty-text="isLoading ? ' ' : '暂无数据'">
            <el-table-column label="#" type="index" min-width="50"/>
            <el-table-column
                label="时间"
                width="110">
                <template v-slot="{ row }">
                    <p>{{ getTime(row.create_time).y_m_d }}</p>
                    <p>{{ getTime(row.create_time).h_m_s }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="订单号"
                min-width="180">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.order_no }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                label="商品件数"
                min-width="80">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ get(row, 'goods_list.length') }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                label="商品总价(元)"
                min-width="120">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper v-numberAlign>{{ row.subtotal }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                label="总优惠(元)"
                min-width="120">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper v-numberAlign>{{ getSum(get(row, 'member_discount_amount'), get(row, 'deal.discount_amount'), get(row, 'deal.round_down_amount')) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                label="应付(元)"
                min-width="120">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper v-numberAlign>{{ row.actual_payment }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                label="实付(元)"
                min-width="120">
                <template v-slot="{ row }">
                    <p class="should-pay text-popper" v-textPopper v-numberAlign>{{ row.actual_payment }}</p>
                    <p class="should-pay danger" v-if="get(row, 'refund.length') > 0">(已全额退款)</p>
                </template>
            </el-table-column>
            <el-table-column min-width="20"/>
            <el-table-column
                label="收银员"
                min-width="180">
                <template v-slot="{ row }">
                    <user-info v-if="get(row, 'creator.id') != null" :userInfo="get(row, 'creator.user')"/>
                    <span class="fs-14 color-333" v-else>线上自助充值</span>
                </template>
            </el-table-column>
            <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && saleRecord.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
    </div>
</template>

<script lang="ts">
import { onBeforeMount, onMounted, ref, createComponent } from '@vue/composition-api'
import { openMessage, useScrollLoad } from '@/utils/system.tsx'
import $fetch from '@/api'
import clone from 'lodash/cloneDeep'
import get from 'lodash/get'
import { setObjectItemToFixed, getSum } from '@/utils/index'

export default {
    setup(props, ctx) {
        const query = ctx.root.$route.query
        const id: string | Array<string | null> = query.id
        const intId: number = +id
        // reactive data
        const saleRecord = ref([])
        const isLoading = ref(false)
        const {
            page: oPage,
            isHasMore,
            isLoading: isScrollLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        onBeforeMount(() => {
            isLoading.value = true
            getSaleRecord().then(() => isLoading.value = false)
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getSaleRecord
            })
        })

        const getTime = (t: string) => {
            if (!t) { return {} }
            const arr = t.split(' ')
            return {
                y_m_d: arr[0],
                h_m_s: arr[1]
            }
        }

        const getSaleRecord = (page = oPage.value, limit = 20) => {
            return $fetch.post({
                url: '/membership/memberconsumerecords',
                params: {
                    member_id: intId,
                    page,
                    limit
                }
            }).then(data => {
                console.log('消费记录', clone(data))
                data = setObjectItemToFixed(data)
                if (page === 1) {
                    saleRecord.value = data.order_list
                    initScrollLoad(data)
                } else {
                    saleRecord.value = saleRecord.value.concat(data.order_list)
                }
                return data
            }).catch(e => openMessage('error', e.message || '获取消费记录信息失败'))
        }

        return {
            isScrollLoading,
            isHasMore,
            isLoading,
            getTime,
            saleRecord,
            // methods
            get,
            getSum
        }
    }
}
</script>

<style lang="scss" scoped>
.required {
    margin: 10px 10px 0;
    font-size: 14px;
    color: #151515;
    letter-spacing: 0;
    line-height: 20px;
}

.should-pay {
    line-height: 1;

    &.danger {
        font-size: 12px;
        color: #E51C23;
    }
}
</style>